import React, {useState, useEffect, useRef} from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { auth, database } from "../config/firebaseConfig";
import { collection, addDoc, doc, updateDoc, query, where, getDocs } from "firebase/firestore";
import AlertBox from '../components/AlertBox';
import AlertOnLoading from '../components/AlertOnLoading';
import { Toaster } from 'react-hot-toast';
import { StarIcon } from "@heroicons/react/24/solid";
import { sendPasswordResetEmail } from 'firebase/auth';
import { UserAuth } from '../App';

function MyProfile() {
    const WAIT_TIME = 5000; //Waits for 5s
    const notInitialRender = useRef(false);

    const SUCCESS = "success"
    const WARNING = "warning"
    const DANGER = "danger"
    
    const {user} = UserAuth();

    const [newDataReviewUserId, setNewDataReviewUserId] = useState(true);

    const stars = Array(5).fill(0);
    const [reviewDescription, setReviewDescription] = useState("");
    const [currentValue, setCurrentValue] = useState(0);
    const [hoverValue, setHoverValue] = useState(undefined);
    const [userName, setUserName] = useState(user.name);
    const [userLastName, setUserLastName] = useState(user.lastname);
    const [userEmail, setUserEmail] = useState(user.email);
    const [userAddress, setUserAddress] = useState("");
    const [userPhone, setUserPhone] = useState("");
    const [userDate, setUserDate] = useState("");
    const [recoverEmail, setRecoverEmail] = useState("");
    const [reviewUserId, setReviewUserId] = useState("");

    const handleClick = value => {
        setCurrentValue(value)
    };

    const handleMouseOver = value => {
        setHoverValue(value)
    };

    const handleMouseLeave = () => {
        setHoverValue(undefined)
    };

    async function forgotPasswordHandler() {
        if (recoverEmail === "") {
            AlertBox(WARNING, '¡Debe escribir un correo válido!');
            return;
        } else if (recoverEmail !== user.email){
            AlertBox(DANGER, '¡Debe escribir su correo electrónico!');
            return;
        }else {
            await sendPasswordResetEmail(auth, recoverEmail)
            setRecoverEmail("");
            AlertBox(SUCCESS, 'Contraseña Cambiada!');
            return;
        }
    }

    // Función para crear las reseñas, si existe ya una, hace un update, sino la crea
    async function createReview() {
        if (reviewDescription === "") {
            AlertBox(WARNING, '¡Debe escribir un cuerpo para la reseña!');
            return;

        } else {
            const reviewRef = collection(database, "reviews");

            //Si el usuario no ha creado ninguna, procede a crear una
            if (reviewUserId !== []) {

                const newReviewRef = doc(database, "reviews", reviewUserId[0].id);
                await updateDoc(newReviewRef, {userName: user.name.concat(" ", user.lastname),
                description: reviewDescription,
                rating: currentValue});
                
                setReviewDescription("");
                setCurrentValue(0);
                AlertBox(SUCCESS, 'Reseña enviada!');
                return;

            } else {
                console.log("Agregar reseña");
                
                await addDoc(reviewRef, {
                userId: user.id,
                userName: user.name.concat(" ", user.lastname),
                description: reviewDescription,
                rating: currentValue});
        
                setReviewDescription("");
                setCurrentValue(0);
                AlertBox(SUCCESS, 'Reseña enviada!');
                return;
            }
        }

    }

    /*
    Updates a Test
    */
    async function updateProfile() {
        const updateProfileRef = doc(database, 'users', user.id);
        await updateDoc(updateProfileRef, {name:userName, lastname:userLastName, email:userEmail, address:userAddress, phone:userPhone, date:userDate});

        setUserName("");
        setUserLastName("");
        setUserEmail("");
        setUserAddress("");
        setUserPhone("");
        setUserDate("");
        return;
    }

        /*
    Gets aboutUs current info
    */
    useEffect(() => {
        if (notInitialRender.current && newDataReviewUserId){
            AlertOnLoading(WAIT_TIME+100);
            
        } else {
            notInitialRender.current = true;
        }

        const interval = setInterval(() => { //Autorize re-render
            if (newDataReviewUserId) {
                const reviewRef = collection(database, "reviews");
                const reviewQuery = query(reviewRef, where("userId", "==", `${user.id}`));
                //Busca en las reviews si ya el usuario creó una
                const getReviewUserId = async() => {
                    const data = await getDocs(reviewQuery);
                    setReviewUserId(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                    
                }
                getReviewUserId();
                console.log("Actualizo");
                setNewDataReviewUserId(!newDataReviewUserId);
                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [reviewUserId, newDataReviewUserId])

  return (
    <div>

        <div>
            <Toaster
            toastOptions={{
                duration:3000,
            }}/>
        </div>

        <Navbar activePage={"/MyProfile"} />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>
        <div className='w-full h-96 bg-white flex justify-center items-center'>
            
            {/* SVG para mobile */}
            <svg className='sm:hidden absolute left-0 top-0' width="133" height="188" viewBox="0 0 133 188" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M28.8272 0.0568313C54.0903 1.26829 68.5671 25.8733 85.5013 44.6609C104.768 66.0364 142.615 86.9098 130.739 113.123C118.481 140.177 74.0388 115.302 47.4759 128.587C19.76 142.449 12.3119 192.716 -18.2585 187.642C-48.8638 182.561 -58.0613 141.319 -61.5511 110.49C-64.5625 83.8867 -52.0542 59.5962 -35.0982 38.8777C-18.4862 18.5795 2.62914 -1.19947 28.8272 0.0568313Z" fill="#3B8EED"/>
            </svg>

            <svg className='sm:hidden absolute left-0 top-3' width="117" height="157" viewBox="0 0 117 157" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M29.9222 0.0474602C51.0396 1.05916 63.1407 21.607 77.2959 37.2966C93.401 55.1474 125.037 72.5789 115.11 94.4694C104.864 117.062 67.7145 96.2896 45.5106 107.384C22.3429 118.96 16.1171 160.938 -9.43657 156.701C-35.0195 152.458 -42.7076 118.017 -45.6247 92.2708C-48.142 70.0543 -37.6863 49.7691 -23.5129 32.467C-9.62693 15.5159 8.02333 -1.00168 29.9222 0.0474602Z" fill="#93C1F7"/>
            </svg>

            <svg className='absolute sm:hidden inset-y-36 right-12' width="101" height="127" viewBox="0 0 101 127" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M55.553 0.177718C72.5602 1.16658 91.1605 8.01376 99.0199 23.0911C106.113 36.6995 92.0144 51.2316 90.0986 66.4502C88.6403 78.0347 95.5711 90.2629 89.3212 100.135C81.9699 111.746 69.0075 118.104 55.553 121.015C37.7685 124.862 13.9183 133.374 3.08488 118.788C-8.01547 103.843 14.3595 85.0383 15.0254 66.4502C15.6386 49.3331 -2.23652 32.3458 6.70536 17.7236C16.0744 2.40306 37.5927 -0.866555 55.553 0.177718Z" fill="#3B8EED"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M55.553 0.177718C72.5602 1.16658 91.1605 8.01376 99.0199 23.0911C106.113 36.6995 92.0144 51.2316 90.0986 66.4502C88.6403 78.0347 95.5711 90.2629 89.3212 100.135C81.9699 111.746 69.0075 118.104 55.553 121.015C37.7685 124.862 13.9183 133.374 3.08488 118.788C-8.01547 103.843 14.3595 85.0383 15.0254 66.4502C15.6386 49.3331 -2.23652 32.3458 6.70536 17.7236C16.0744 2.40306 37.5927 -0.866555 55.553 0.177718Z" fill="#3B8EED"/>
            </svg>

            <svg className='absolute sm:hidden inset-y-40 right-14 ' width="85" height="107" viewBox="0 0 85 107" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M46.7525 0.149731C61.0655 0.982864 76.7193 6.75175 83.3335 19.4547C89.3034 30.92 77.4378 43.1637 75.8255 55.9856C74.5982 65.7457 80.4311 76.0483 75.1713 84.3653C68.9846 94.1481 58.0756 99.5052 46.7525 101.957C31.7854 105.198 11.7134 112.37 2.59618 100.081C-6.7457 87.4899 12.0847 71.6464 12.6451 55.9856C13.1612 41.5641 -1.88222 27.2519 5.64313 14.9325C13.5279 2.02463 31.6375 -0.730089 46.7525 0.149731Z" fill="#3B8EED"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M46.7525 0.149731C61.0655 0.982864 76.7193 6.75175 83.3335 19.4547C89.3034 30.92 77.4378 43.1637 75.8255 55.9856C74.5982 65.7457 80.4311 76.0483 75.1713 84.3653C68.9846 94.1481 58.0756 99.5052 46.7525 101.957C31.7854 105.198 11.7134 112.37 2.59618 100.081C-6.7457 87.4899 12.0847 71.6464 12.6451 55.9856C13.1612 41.5641 -1.88222 27.2519 5.64313 14.9325C13.5279 2.02463 31.6375 -0.730089 46.7525 0.149731Z" fill="#93C1F6"/>
            </svg>

            <svg className='sm:hidden absolute inset-y-80 -my-4 right-0' width="72" height="154" viewBox="0 0 94 154" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M81.2292 0.0180846C97.2733 0.485145 107.871 13.219 114.942 27.6659C130.266 58.9738 163.648 93.9549 139.487 119.043C106.299 153.505 45.6091 168.621 10.9042 135.696C-19.5894 106.766 21.5409 62.8594 40.8998 25.5105C49.0017 9.87969 63.6671 -0.493168 81.2292 0.0180846Z" fill="#3B8EED"/>
            </svg>

            <svg className='sm:hidden absolute inset-y-80 right-0' width="56" height="132" viewBox="0 0 81 132" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M69.1546 0.0155011C82.8138 0.415838 91.8361 11.3305 97.8561 23.7136C110.902 50.5489 139.322 80.5328 118.752 102.037C90.4975 131.576 38.8294 144.533 9.28329 116.311C-16.6774 91.5134 18.3389 53.8795 34.8201 21.8661C41.7176 8.46831 54.2031 -0.422715 69.1546 0.0155011Z" fill="#93C1F6"/>
            </svg>

            {/* SVGs para desktop */}
            <svg className='hidden absolute sm:block sm:left-0' width="133" height="188" viewBox="0 0 133 188" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M28.8272 0.0568313C54.0903 1.26829 68.5671 25.8733 85.5013 44.6609C104.768 66.0364 142.615 86.9098 130.739 113.123C118.481 140.177 74.0388 115.302 47.4759 128.587C19.76 142.449 12.3119 192.716 -18.2585 187.642C-48.8638 182.561 -58.0613 141.319 -61.5511 110.49C-64.5625 83.8867 -52.0542 59.5962 -35.0982 38.8777C-18.4862 18.5795 2.62914 -1.19947 28.8272 0.0568313Z" fill="#3B8EED"/>
            </svg>

            <svg className='hidden absolute sm:block sm:left-0' width="117" height="157" viewBox="0 0 117 157" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M29.9222 0.0474602C51.0396 1.05916 63.1407 21.607 77.2959 37.2966C93.401 55.1474 125.037 72.5789 115.11 94.4694C104.864 117.062 67.7145 96.2896 45.5106 107.384C22.3429 118.96 16.1171 160.938 -9.43657 156.701C-35.0195 152.458 -42.7076 118.017 -45.6247 92.2708C-48.142 70.0543 -37.6863 49.7691 -23.5129 32.467C-9.62693 15.5159 8.02333 -1.00168 29.9222 0.0474602Z" fill="#93C1F7"/>
            </svg>

            <svg className='hidden absolute sm:block inset-y-36 right-12 md:right-28 form1:right-80' width="101" height="127" viewBox="0 0 101 127" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M55.553 0.177718C72.5602 1.16658 91.1605 8.01376 99.0199 23.0911C106.113 36.6995 92.0144 51.2316 90.0986 66.4502C88.6403 78.0347 95.5711 90.2629 89.3212 100.135C81.9699 111.746 69.0075 118.104 55.553 121.015C37.7685 124.862 13.9183 133.374 3.08488 118.788C-8.01547 103.843 14.3595 85.0383 15.0254 66.4502C15.6386 49.3331 -2.23652 32.3458 6.70536 17.7236C16.0744 2.40306 37.5927 -0.866555 55.553 0.177718Z" fill="#3B8EED"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M55.553 0.177718C72.5602 1.16658 91.1605 8.01376 99.0199 23.0911C106.113 36.6995 92.0144 51.2316 90.0986 66.4502C88.6403 78.0347 95.5711 90.2629 89.3212 100.135C81.9699 111.746 69.0075 118.104 55.553 121.015C37.7685 124.862 13.9183 133.374 3.08488 118.788C-8.01547 103.843 14.3595 85.0383 15.0254 66.4502C15.6386 49.3331 -2.23652 32.3458 6.70536 17.7236C16.0744 2.40306 37.5927 -0.866555 55.553 0.177718Z" fill="#3B8EED"/>
            </svg>

            <svg className='hidden absolute sm:block inset-y-40 right-14 md:right-32 md:-mx-2 form1:right-80 form1:mx-2' width="85" height="107" viewBox="0 0 85 107" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M46.7525 0.149731C61.0655 0.982864 76.7193 6.75175 83.3335 19.4547C89.3034 30.92 77.4378 43.1637 75.8255 55.9856C74.5982 65.7457 80.4311 76.0483 75.1713 84.3653C68.9846 94.1481 58.0756 99.5052 46.7525 101.957C31.7854 105.198 11.7134 112.37 2.59618 100.081C-6.7457 87.4899 12.0847 71.6464 12.6451 55.9856C13.1612 41.5641 -1.88222 27.2519 5.64313 14.9325C13.5279 2.02463 31.6375 -0.730089 46.7525 0.149731Z" fill="#3B8EED"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M46.7525 0.149731C61.0655 0.982864 76.7193 6.75175 83.3335 19.4547C89.3034 30.92 77.4378 43.1637 75.8255 55.9856C74.5982 65.7457 80.4311 76.0483 75.1713 84.3653C68.9846 94.1481 58.0756 99.5052 46.7525 101.957C31.7854 105.198 11.7134 112.37 2.59618 100.081C-6.7457 87.4899 12.0847 71.6464 12.6451 55.9856C13.1612 41.5641 -1.88222 27.2519 5.64313 14.9325C13.5279 2.02463 31.6375 -0.730089 46.7525 0.149731Z" fill="#93C1F6"/>
            </svg>

            <svg className='hidden absolute sm:block inset-y-60 right-0' width="94" height="154" viewBox="0 0 94 154" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M81.2292 0.0180846C97.2733 0.485145 107.871 13.219 114.942 27.6659C130.266 58.9738 163.648 93.9549 139.487 119.043C106.299 153.505 45.6091 168.621 10.9042 135.696C-19.5894 106.766 21.5409 62.8594 40.8998 25.5105C49.0017 9.87969 63.6671 -0.493168 81.2292 0.0180846Z" fill="#3B8EED"/>
            </svg>

            <svg className='hidden absolute sm:block inset-y-64 right-0' width="81" height="132" viewBox="0 0 81 132" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M69.1546 0.0155011C82.8138 0.415838 91.8361 11.3305 97.8561 23.7136C110.902 50.5489 139.322 80.5328 118.752 102.037C90.4975 131.576 38.8294 144.533 9.28329 116.311C-16.6774 91.5134 18.3389 53.8795 34.8201 21.8661C41.7176 8.46831 54.2031 -0.422715 69.1546 0.0155011Z" fill="#93C1F6"/>
            </svg>

            {/* Cuadro de título */}
            <div className='w-80 h-36 bg-primary-200 sm:w-96 lg:w-6/12 max-w-table-web rounded-xl text-white flex justify-center items-center z-10'>
                <h2 className='text-3xl lg:text-4xl'>Administra tu Perfil</h2>
            </div>

        </div>

        {/* Sección de identidad */}
        <div className='px-4 py-6 w-full h-auto bg-white lg:py-8 sm:px-8 my-6'>
            <h2 className='lg:text-xl'>Identidad</h2>
            <span className='lg:w-80 w-48 flex flex-col border border-primary-100'></span>

            {/* Sección de editar perfil */}
            <div className="flex flex-col space-y-0 py-6 justify-center items-center w-full h-auto lg:space-y-0">

                <div className='flex flex-col w-80 h-auto text-sm bg-profilebox text-white rounded-t-xl sm:w-96 form1:text-xl lg:w-full lg:flex-row max-w-table-web z-10 '>
                    <div className='px-3 py-4 space-y-2 text-left flex flex-col w-80 h-auto text-sm bg-profilebox text-white rounded-xl sm:w-96 form1:text-xl lg:w-full lg:flex-col max-w-table-web z-10'>
                        <div className='flex flex-row space-x-7'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-16'>Nombre:</h2>
                            <input onChange={(ev) => {setUserName(ev.target.value)}} value={userName} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-full lg:w-9/12 h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>

                        <div className='flex flex-row space-x-7'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-16'>Apellido:</h2>
                            <input onChange={(ev) => {setUserLastName(ev.target.value)}} value={userLastName} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-full lg:w-9/12 h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>

                        <div className='flex flex-row space-x-8 lg:space-x-3'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-20'>Correo:</h2>
                            <input onChange={(ev) => {setUserEmail(ev.target.value)}} value={userEmail} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-full lg:w-9/12 h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md pointer-events-none px-2'/>
                        </div>

                        <div className='flex flex-row space-x-8 lg:hidden'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-14'>Dirección:</h2>
                            <input onChange={(ev) => {setUserAddress(ev.target.value)}} value={userAddress} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-full h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>

                        <div className='flex flex-row space-x-7 lg:hidden'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-16'>Teléfono:</h2>
                            <input onChange={(ev) => {setUserPhone(ev.target.value)}} value={userPhone} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-full h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>
                            
                        
                        <div className='flex flex-row space-x-8 lg:hidden'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-14'>Fecha de Nacimiento:</h2>
                            <input onChange={(ev) => {setUserDate(ev.target.value)}} value={userDate} type={"date"}
                            className='text-sm rounded-xl sm:text-base w-full h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>
                    </div>

                    {/* Segunda sección para desktop */}
                    <div className='hidden py-4 space-y-2 text-left lg:flex flex-col w-80 h-auto text-sm bg-profilebox text-white rounded-xl sm:w-96 form1:text-xl lg:w-full lg:flex-col max-w-table-web z-10'>
                        <div className='flex flex-row space-x-12'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-14'>Dirección:</h2>
                            <input onChange={(ev) => {setUserAddress(ev.target.value)}} value={userAddress} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-9/12 h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>

                        <div className='flex flex-row space-x-10'>
                            <h2 className='lg:text-xl flex items-center text-black font-bold w-16'>Teléfono:</h2>
                            <input onChange={(ev) => {setUserPhone(ev.target.value)}} value={userPhone} type={"text"}
                            className='text-sm rounded-xl sm:text-base w-9/12 h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>
                            
                        
                        <div className='flex flex-row space-x-12'>
                            <h2 className='lg:text-base flex items-center text-black font-bold w-14'>Fecha de Nacimiento:</h2>
                            <input onChange={(ev) => {setUserDate(ev.target.value)}} value={userDate} type={"date"}
                            className='text-sm rounded-xl sm:text-base w-9/12 h-input-height text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                        </div>
                    </div>
                </div>

                {/* Botón de actualizar */}
                <div className='flex justify-center lg:my-10 flex-col w-80 h-auto text-sm bg-profilebox text-white rounded-b-xl sm:w-96 form1:text-xl lg:w-full lg:flex-row max-w-table-web z-10'>
                    <div className='w-full lg:w-1/3 flex justify-center'>
                        <button onClick={updateProfile} 
                        className='w-1/2 my-3 h-9 text-sm sm:text-base sm:h-9 mx-12 sm:mx-0 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>
                        Actualizar</button>
                    </div>
                </div>
            </div>
        </div>

        {/* Sección de Seguridad */}
        <div className='px-4 py-6 flex flex-col w-full h-auto bg-white lg:py-8 sm:px-8 my-6'>
            <h2 className='lg:text-xl'>Seguridad</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>

            <div className='flex flex-col w-full h-auto items-center justify-center'>
                <div className='px-4 pt-6 pb-2 flex flex-col w-full h-auto bg-white lg:py-8 sm:px-8 my-6 items-center'>
                    <h2 className='lg:text-xl'>Cambiar Contraseña</h2>
                    <span className='lg:w-80 w-48 border border-primary-100'></span>
                </div>

                <div className='space-y-4 px-3 py-4 text-left flex justify-center flex-col w-80 h-48 text-sm bg-profilebox text-white rounded-xl sm:w-96 form1:text-xl lg:w-full max-w-table-web z-10'>
                    <h2 className='text-center text-black lg:text-xl'>Para cambiar la contraseña, escriba su correo electrónico</h2>
                    
                    <div className='flex flex-row'>
                        <h2 className='text-black text-center font-bold text-xs w-4/5 my-2 lg:text-xl lg:w-1/2'>Correo Electrónico:</h2>
                        <input onChange={(ev) => {setRecoverEmail(ev.target.value)}} value={recoverEmail} type={"text"}
                        className='text-sm rounded-xl sm:text-base w-full h-input-height text-input-font text-start bg-background
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md px-2'/>
                    </div>

                    <div className='w-full flex justify-center'>
                        <button onClick={forgotPasswordHandler} 
                        className='w-2/12 my-3 h-9 text-sm sm:text-base sm:h-9 mx-12 sm:mx-0 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>
                        Enviar</button>
                    </div>
                </div>
            </div>
        </div>

        <div className='px-4 py-6 flex flex-col w-full h-auto bg-white lg:py-8 sm:px-8'>

            <h2 className='lg:text-xl'>Reseña</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>

            <div className="flex space-y-4 px-4 py-6 justify-center w-full">
                
                <div className='px-3 py-4 text-left flex justify-center flex-col w-80 h-48 text-sm bg-profilebox text-white rounded-xl sm:w-96 form1:text-xl lg:w-full lg:flex-row lg:items-center max-w-table-web z-10 lg:space-x-4'>
                    <div className='lg:w-2/3'>
                        <textarea className="px-2 py-1 md:text-base rounded-xl  h-text-area-height w-full lg:h-40 text-sm text-input-font bg-background
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none"
                        onChange={(ev) => {setReviewDescription(ev.target.value)}} value={reviewDescription}
                        id="description" name="description" rows="7" cols="41" placeholder='Ingrese su comentario...'></textarea>
                    </div>

                    <div className='flex flex-row space-x-9 lg:flex-col lg:space-x-0 lg:justify-center lg:items-center lg:w-1/3'>
                        <div className='w-full flex flex-row justify-center'>
                            {stars.map((_, index) => {
                                return(
                                    <StarIcon key={index} className={`${(hoverValue || currentValue) > index ? "text-star" : "text-white"} cursor-pointer max-h-14 max-w-14`}
                                    onClick={() => handleClick(index + 1)}
                                    onMouseOver={() => handleMouseOver(index + 1)}
                                    onMouseLeave={handleMouseLeave}/>
                                )
                            })}
                        </div>
                        <div className='w-full flex justify-center'>
                            <button onClick={createReview} 
                            className='w-1/2 my-3 h-9 text-sm sm:text-base sm:h-9 mx-12 sm:mx-0 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>
                            Enviar</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <Footer />
    </div>
  )
}

export default MyProfile;